const ADD_CART_TO_WISHLIST = 'ADD_CART_TO_WISHLIST';
const ADD_CART_TO_WISHLIST_FULFILLED = 'ADD_CART_TO_WISHLIST_FULFILLED';
const ADD_CART_TO_WISHLIST_REJECTED = 'ADD_CART_TO_WISHLIST_REJECTED';
const CLEAR_ADD_CART_TO_WISHLIST = 'CLEAR_ADD_CART_TO_WISHLIST';
const CLEAR_CART = 'CLEAR_CART';
const FETCH_CART = 'FETCH_CART';
const FETCH_CART_FULFILLED = 'FETCH_CART_FULFILLED';
const FETCH_CART_REJECTED = 'FETCH_CART_REJECTED';
const REMOVE_CART = 'REMOVE_CART';
const REMOVE_CART_FULFILLED = 'REMOVE_CART_FULFILLED';
const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
const REPLACE_CART = 'REPLACE_CART';
const UPDATE_ITEM_QUANTITY = 'UPDATE_ITEM_QUANTITY';
const UPDATE_ITEM_QUANTITY_FULFILLED = 'UPDATE_ITEM_QUANTITY_FULFILLED';
const UPDATE_ITEM_QUANTITY_REJECTED = 'UPDATE_ITEM_QUANTITY_REJECTED';
const UPDATE_ITEM_REFERENCE = 'UPDATE_ITEM_REFERENCE';
const UPDATE_VOUCHER = 'UPDATE_VOUCHER';
const ADD_ITEMS_TO_CART = 'ADD_ITEMS_TO_CART';
const ADD_ITEMS_TO_CART_FULFILLED = 'ADD_ITEMS_TO_CART_FULFILLED';
const ADD_ITEMS_TO_CART_REJECTED = 'ADD_ITEMS_TO_CART_REJECTED';
const CLEAR_ADD_ITEMS_TO_CART = 'CLEAR_ADD_ITEMS_TO_CART';

const ACTIONS_TO_SYNC = [
  CLEAR_CART,
  FETCH_CART_FULFILLED,
  FETCH_CART_REJECTED,
  REPLACE_CART,
];

export {
  ACTIONS_TO_SYNC,
  ADD_CART_TO_WISHLIST,
  ADD_CART_TO_WISHLIST_FULFILLED,
  ADD_CART_TO_WISHLIST_REJECTED,
  ADD_ITEMS_TO_CART,
  ADD_ITEMS_TO_CART_FULFILLED,
  ADD_ITEMS_TO_CART_REJECTED,
  CLEAR_ADD_CART_TO_WISHLIST,
  CLEAR_ADD_ITEMS_TO_CART,
  CLEAR_CART,
  FETCH_CART,
  FETCH_CART_FULFILLED,
  FETCH_CART_REJECTED,
  REMOVE_CART,
  REMOVE_CART_FULFILLED,
  REMOVE_VOUCHER,
  REPLACE_CART,
  UPDATE_ITEM_QUANTITY,
  UPDATE_ITEM_QUANTITY_FULFILLED,
  UPDATE_ITEM_QUANTITY_REJECTED,
  UPDATE_ITEM_REFERENCE,
  UPDATE_VOUCHER,
};
